import { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import DefaultLayout from '../../layout/DefaultLayout/DefaultLayout';
import { moreAboutPt, moreAboutEng } from '../../translation/moreAbout';
import './MoreAbout.scss';

function MoreAbout() {
    let { languageIndex } = useContext(LanguageContext);
    let moreAbout = !languageIndex ? moreAboutPt : moreAboutEng;

    return (
        <DefaultLayout>
            <h1>{ moreAbout.title }</h1>
            <div className='text-holder'>
                {moreAbout.sections.map((section) =>
                    <>
                        <h2 className='micro-titles'>{ section.subtitle }</h2>
                        <ul>
                            {section.items.map((item, index) =>
                                <li key={index}>{ item }</li>
                            )}
                        </ul>
                    </>
                )}
            </div>
        </DefaultLayout>
    )
}

export default MoreAbout;
